import React from "react";
import "./style.scss";
import classNames from "classnames";
import SuperButton from "../../elements/super-button";
const CTAButton = ({ fields, rendering }) => {
  if (!fields) return null;
  const { paddingAboveTop, paddingAboveBottom, gridType, backgroundColor, alignment, items } = fields;
  let grid = gridType ? gridType.fields.phrase.value : "normal",
    top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "tiny",
    bottom = paddingAboveBottom ? paddingAboveBottom.fields.phrase.value : "deafult";
  const ctaClasses = classNames("cta", "padding-top-" + top, "padding-bottom-" + bottom, {
      grid: grid === "normal",
      "grid-story": grid === "story",
      center: alignment && alignment.fields.phrase.value === "center",
      right: alignment && alignment.fields.phrase.value === "right"
    }),
    primaryClasses = classNames("primary");
  // secondaryClasses = classNames("secondary");

  const backgroundStyle = {
    background: backgroundColor && backgroundColor.fields && backgroundColor.fields.phrase ? backgroundColor.fields.phrase.value : {}
  };

  return (
    <div className={ctaClasses} style={backgroundStyle} datasourceid={rendering.dataSource}>
      <div className={"button-container grid"}>
        {items &&
          items.map(
            (item, index) =>
              item.fields &&
              item.fields.ctatype && (
                <div key={index} className={primaryClasses}>
                  <SuperButton {...item.fields} />
                </div>
              )
          )}
      </div>
    </div>
  );
};

export default CTAButton;
